import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useFetchDeclarations from '../hooks/useFetchDeclarations';

const InvitationsDeclarations = () => {
    const { declarations, fetchInvitationsDeclarations } = useFetchDeclarations();
    const navigate = useNavigate();

    useEffect(() => {
        fetchInvitationsDeclarations();
    }, []);

    return (
        <div class="flex-1 p-5 lg:p-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12 mt-6 lg:mt-8">
                        <h1 class="mb-10 w-full font-bold text-gray-800 text-4xl text-center">Mes Invitations</h1>
                        <div class="flex md:flex-row flex-col gap-4 mx-auto px-4 md:px-20 md:py-10">
                            {
                                declarations.length === 0 ? (
                                    <p class="text-gray-500 text-center">Aucune invitation disponible.</p>
                                ) : (
                                    declarations.map((declaration) => (
                                        <div  key={declaration.UUID_} onClick={() => navigate(`/declarations/${declaration.UUID_}`)} class="shadow-lg mx-auto rounded-md md:w-1/3 h-104 overflow-hidden">
                                            <div class="relative">
                                                <img src="https://images.pexels.com/photos/1559402/pexels-photo-1559402.jpeg" alt="mountain" class="w-full h-48 hover:h-64 object-cover object-left-top hover:transition duration-150 ease-in-out" />
                                                <div class="top-0 right-0 absolute">
                                                    <div class="flex justify-end gap-8 px-6 py-4 text-white">
                                                        <a href="#">
                                                            <i class="fas fa-ellipsis-v"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                                {/* <div class="bottom-0 absolute -mb-6 px-4">
                                                    <a href="#" class="flex justify-center items-center bg-blue-500 shadow-md p-4 rounded-full w-12 h-12">
                                                        <i class="text-white fas fa-paper-plane"></i>
                                                    </a>
                                                </div> */}
                                            </div>
                                            <div class="flex flex-col bg-white py-8 overflow-hidden">
                                                <a href="#" class="flex items-center gap-4 px-6 py-3 w-full">
                                                    <div class="flex justify-center items-center bg-orange-600 p-4 rounded-full w-10 h-10">
                                                        <i class="text-white fas fa-scroll"></i>
                                                    </div>
                                                    <div class="flex-grow">
                                                        <h5 class="font-semibold text-gray-700 text-lg leading-tight">{declaration.Libelle}</h5>
                                                        {/* <span class="text-gray-500 text-sm">May 9, 2015</span> */}
                                                    </div>
                                                    <i class="text-gray-500 fas fa-info-circle"></i>
                                                </a>
                                                <a href="#" class="flex items-center gap-4 px-6 py-3 w-full">
                                                    <div class="flex justify-center items-center bg-orange-600 p-4 rounded-full w-8 h-8">
                                                        <i class="text-white fas fa-city"></i>
                                                    </div>
                                                    <div class="flex-grow">
                                                        <h5 class="font-semibold text-gray-700 text-sm leading-tight">{declaration.SiteNom}</h5>
                                                        <span class="text-gray-500 text-xs">{declaration.Adresse}</span>
                                                    </div>
                                                    <i class="text-gray-500 fas fa-info-circle"></i>
                                                </a>
                                            </div>
                                        </div>
                                    ))
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvitationsDeclarations;